//Import Libraires
import React, { createContext, useState, useEffect } from "react";

//Import Firebase
import firebase from "../firebase/firebase";

//Create Context
const UserContext = createContext();

// firestore
const userDocument = firebase.firestore().collection("users");

export const UserProvider = ({ children }) => {
  //User State Values
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});

  // Initializing FireStore User Document
  useEffect(() => {
    const id = firebase.auth().currentUser
      ? firebase.auth().currentUser.uid
      : null;
    if (id) {
      userDocument.doc(id).onSnapshot((documentSnapshot) => {
        const userData = documentSnapshot.data();
        setUserData(userData);
      });
    }
  }, [user]);
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        loading,
        setLoading,
        userData,

        // Forgot Password Method
        forgotPassword: async (Email) => {
          setLoading(true);
          firebase
            .auth()
            .sendPasswordResetEmail(Email)
            .then(function (user) {
              setLoading(false);
              return true;
            })
            .catch((err) => {
              return false;
            });
        },
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
